import React from 'react';
import { source_map } from './util'

interface Iprops {
    data: {
      ad?: boolean
      address?: string
      bedroom?: string
      distance?: number
      first_available?: string
      link?: string
      photo?: string
      price?: number
      source?: number
      location?: string
    }
}

function Card(props: Iprops) {

  const {
    data: {
      source,
      bedroom,
      distance,
      link,
      price,
      location
    }
  } = props
  return (
    <div className=' rounded-[8px] border border-lines p-[20px]'>
      {
        source === 0 ?
          <div className=' font-[500] text-black text-base'>
            <div>{`Thought you might be interested in this Month2Month home located at ${location}. It is a ${bedroom}B beautifully fully furnished home with flexible lease terms which is only ${distance} miles away from ${location}. `}</div>
            <div className='mt-[12px]'>{`Please use this link below to explore more about this home, currently priced at $${price}+/30 days. `}</div>
            <div className='mt-[12px]'><a className='text-blue' target={'_blank'} href={link} rel="noreferrer">{link}</a></div>
            <div className='mt-[12px]'>Some of the benefits of working with Month2month include:</div>
            <ul className=' list-outside list-disc pl-[20px]'>
              <li>Month-to-Month rentals with flexible lease terms</li>
              <li>Professionally managed homes located throughout Texas, California, Florida, Nevad, South Carolina and Oregon with additional markets coming on daily throughout the United States</li>
              <li>Everything’s included in your temporary housing including furniture, kitchen housewares, home electronics, utilities, and more</li>
            </ul>
          </div> :
          <div className=' font-[500] text-black text-base'>
            <div>{`We found this home for you from ${source_map[source || 0]}. It is a ${bedroom}B beautifully fully furnished home with flexible lease terms which is only ${distance} miles away from ${location}.  `}</div>
            <div className='mt-[12px]'>{`Please use this link below to explore more about this home, currently priced at ${price}+/30 days. `}</div>
            <div className='mt-[12px]'><a className=' text-blue' target={'_blank'} href={link} rel="noreferrer">{link}</a></div>
          </div>
      }
    </div>
  );
}

export default Card;
